var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiletype = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 35,
  height: 41,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.828.5v8.004h7.753v31.082H.5V.5h25.328Z",
  stroke: "url(#filetype_svg__a)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m25.846.531 7.735 7.973",
  stroke: "url(#filetype_svg__b)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.986 22.04c.811 0 1.47-.654 1.47-1.462 0-.807-.659-1.462-1.47-1.462-.812 0-1.47.655-1.47 1.462 0 .808.658 1.463 1.47 1.463Z",
  stroke: "url(#filetype_svg__c)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.867 31.789H14.012l5.427-10.218 5.428 10.218Z",
  stroke: "url(#filetype_svg__d)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m9.878 31.789 3.882-7.307 2.073 3.902",
  stroke: "url(#filetype_svg__e)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M24.867 16.758H9.217v15.028h15.65V16.758Z",
  stroke: "url(#filetype_svg__f)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "filetype_svg__a",
  x1: 0.67,
  y1: 39.418,
  x2: 34.041,
  y2: 39.418,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#071389"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#071389"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "filetype_svg__b",
  x1: 0.67,
  y1: 8.793,
  x2: 32.781,
  y2: 8.793,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#071389"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#071389"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "filetype_svg__c",
  x1: 0.67,
  y1: 21.918,
  x2: 33.411,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#071389"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#071389"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "filetype_svg__d",
  x1: 0.67,
  y1: 31.918,
  x2: 33.411,
  y2: 31.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#071389"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#071389"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "filetype_svg__e",
  x1: 1.3,
  y1: 31.918,
  x2: 33.411,
  y2: 31.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#071389"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#071389"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "filetype_svg__f",
  x1: 0.67,
  y1: 31.918,
  x2: 33.411,
  y2: 31.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#071389"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#071389"
})))));
export { SvgFiletype as ReactComponent };
export default __webpack_public_path__ + "/assets/5b786d222955d485af6aa6b552eea52b.svg";